<template>
  <div class="container d-flex flex-column">
    <Logged-user />
    <div v-if="loading" class="loading">
      <clip-loader />
    </div>
    <div class="row" v-else>
      <div class="col-12">
        <table class="table table-stripped table-sm mt-2">
          <thead>
            <tr>
              <th>#</th>
              <th>Nom</th>
              <th>Email</th>
              <th>Date d'inscription</th>
              <th>Premium ?</th>
              <th>User id</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(user, index) in users" v-bind:key="user.userId">
              <td>{{index + 1}}</td>
              <td class="username" v-bind:title="user.username">{{user.username}}</td>
              <td>{{user.email}}</td>
              <td>{{user.created}}</td>
              <td v-if="user.premium">OUI</td>
              <td v-else></td>
              <td class="userid">{{user.id}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="mt-auto">
      <bottom-nav />
    </div>
  </div>
</template>

<script>
import LoggedUser from '../LoggedUser.vue';
import BottomNav from '../BottomNav.vue';
import ClipLoader from '../ClipLoader.vue';

const padZero = n => ((n < 10) ? `0${n}` : n);

export default {
  name: 'AdminUsers',
  components: { LoggedUser, BottomNav, ClipLoader },
  data() {
    return {
      users: [],
      loading: true,
    };
  },
  created() {
    this.getUsers().then((users) => {
      this.users = users
        .sort((a, b) => {
          if (a.premium && b.premium) {
            return a.createdAt - b.createdAt;
          }
          if (!a.premium && !b.premium) {
            return a.createdAt - b.createdAt;
          }
          if (a.premium) return -1;
          return 1;
        })
        .map(u => ({
          ...u,
          created: this.toDate(u.createdAt),
        }));
      this.loading = false;
    });
  },
  methods: {
    getUsers() {
      return this.$http.get(`${import.meta.env.VITE_LCT_API_URL}/users`)
        .then(response => response.data);
    },
    toDate(timestamp) {
      const d = new Date(timestamp);
      return `${padZero(d.getDate())}/${padZero(d.getMonth() + 1)}/${d.getFullYear()}`;
    },
  },
};
</script>

<style scoped>
.loading {
  height: 200px;
  margin-top: 30px;
}
.userid{
  font-size: 0.6rem;
}
.username{
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
